export const TEST_ID = 'donutChart';

export const FILL_COLOR_VARIABLE = '--donut-chart-fill-color';

export const VIEW_BOX_SIZE = 36;

export const CENTER = VIEW_BOX_SIZE / 2;

export const RADIUS = 16;

export const FULL_PERCENT = 100;

export const MINIMUM_PERCENT = 0;

export const PERCENT_SYMBOL = '%';
